<template>
  <nav class="navbar is-white">
    <div class="container">
      <div class="navbar-brand">
        <a class="navbar-item brand-text"><img src="@/assets/img/superadmin_logo.png" /></a>
        <div class="navbar-burger burger" data-target="navMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div id="navMenu" class="navbar-menu">
        <div class="navbar-start">
          <a class="navbar-item" v-on:click="goHome()" v-bind:class="isActive('SuperHome')">Home</a>
          <a class="navbar-item" v-on:click="goSchools()" v-bind:class="isActive('SuperSchools')">Schools</a>
          <a class="navbar-item" v-on:click="goSuperItems()" v-bind:class="isActive('SuperItems')">Items</a>
          <a class="navbar-item" v-on:click="goSuperTools()" v-bind:class="isActive('SuperTools')">Tools</a>
          <!-- <a class="navbar-item" v-on:click="goPlans()" v-bind:class="isActive('SuperPlans')">Plans</a>
          <a class="navbar-item" v-on:click="goSettings()" v-bind:class="isActive('SuperSettings')">Settings</a> -->
          <a class="navbar-item" v-on:click="logout()">Logout</a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import "./../public/style.scss";

export default {
  name: "TopMenu",
  data() {
    return {
      currentRouteName: ""
    };
  },
  created() {
    this.currentRouteName = this.$router.currentRoute.name;
  },
  mounted() {
    (function() {
      var burger = document.querySelector(".burger");
      var menu = document.querySelector("#" + burger.dataset.target);
      burger.addEventListener("click", function() {
        burger.classList.toggle("is-active");
        menu.classList.toggle("is-active");
      });
    })();
    this.$root.$on("activeMenu", (item, response) => {
      var name = "";
      if (
        item === "ClassDashboardSingle" ||
        item === "ClassPositiveHistory" ||
        item === "ClassPositiveDetails" ||
        item === "ClassManageStudents"
      ) {
        name = "ClassDashboard";
      } else if (item === "StaffAttendanceDetails") {
        name = "StaffAttendanceMain";
      }

      this.currentRouteName = name;
      this.isActive(name);
    });
  },
  methods: {
    isActive(name) {
      if (name == "GroupDashboard") {
        if (this.currentRouteName.substring(0, 5) == "Group") {
          return "is-active";
        } else {
          return "";
        }
      } else {
        if (this.currentRouteName == name) {
          return "is-active";
        } else {
          return "";
        }
      }
    },
    goHome() {
      this.$router.push({
        name: "SuperHome"
      });
    },
    goSchools() {
      this.$router.push({
        name: "SuperSchools"
      });
    },
    goAdmins() {
      this.$router.push({
        name: "SuperAdmins"
      });
    },
    goSuperItems() {
      this.$router.push({
        name: "SuperItems"
      });
    },
    goSuperTools() {
      this.$router.push({
        name: "SuperTools"
      });
    },
    goPlans() {
      this.$router.push({
        name: "SuperPlans"
      });
    },
    goSettings() {
      this.$router.push({
        name: "SuperSettings"
      });
    },
    logout() {
      localStorage.removeItem("superId");
      localStorage.removeItem("superEmail");
      localStorage.removeItem("jwtToken");
      this.$emit("authenticated", false);

      this.$router.push({
        name: "SuperLogin"
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Super/TopMenu.vue